import SearchConfig from '@sun-chemical/system-config/search-config';
import { cloneObject } from 'utils';
import base from 'stores/search-base/getters';
import { translate } from 'utils/i18n';

export default {
  ...base,
  filters(state, getters, rootState, rootGetters) {
    const filters = cloneObject(state.filterConfig);
    const { urlFilters } = getters;

    Object.keys(filters).forEach((filterCode) => {
      let aggs = getters.aggregations && Array.isArray(getters.aggregations[filterCode]) ? getters.aggregations[filterCode] : null;

      if (aggs && aggs.length > 0 && typeof aggs[0] === 'object') {
        aggs = aggs.map((agg) => agg.key_as_string || agg.key);
      }

      const config = cloneObject(filters[filterCode]);

      if (!config.accessLevel || rootGetters['user/permissions'][config.accessLevel]) {
        const filterParam = SearchConfig.getMap()[filterCode].param;

        filters[filterCode].param = filterParam;

        if (config.type === 'multi' || config.type === 'color' || config.type === 'industry') {
          filters[filterCode].options = [];
          config.options.forEach((option) => {
            const filterObject = {
              ...option,
              selected: null,
              disabled: aggs && aggs.indexOf(option.code) === -1
            };

            if (urlFilters.hasOwnProperty(filterParam)) {
              let activeFilters = urlFilters[filterParam];
              if (typeof activeFilters === 'string') {
                activeFilters = [activeFilters];
              }
              filterObject.selected = activeFilters.indexOf(option.code) > -1;
            }

            // Prevent disabling currently active filters
            if (filterObject.selected && filterObject.disabled) {
              filterObject.disabled = false;
            }

            filters[filterCode].options.push(filterObject);
          });
        }
      } else {
        delete filters[filterCode];
      }
    });

    if (urlFilters.ingredient) {
      const value = state.ingredient ? state.ingredient.productName : urlFilters.ingredient;

      filters.ingredient = {
        type: 'active_filter_tag',
        param: 'ingredient',
        label: translate('formulationRepository.searchPage.ingredientFilterLabel'),
        value,
      };
    }

    return {
      generic: filters
    };
  },
  activeIndustries() {
    return null;
  },
  activeTab(state, getters) {
    return getters.urlFilters.hasOwnProperty('tab')
    && state.availableTabs.indexOf(getters.urlFilters.tab) > -1
      ? getters.urlFilters.tab
      : 'overview';
  },
  isMobile(state) {
    return state.documentWidth <= 960;
  }
};
